import { useMutation } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { getBidReportPDFUrlForExternalUser } from "../public/getBidReportPDFUrlForExternalUser";
import { useExternalBidQuery } from "../public/useExternalBidQuery";

const exportBidReportAsPDF = graphql(`
  mutation exportBidReportAsPDF($input: ExportBidReportRequest!) {
    exportBidReportAsPDF(ExportBidReportRequest: $input) {
      id
      url
    }
  }
`);

export function useExportBidReportAsPDF(
  id: string,
  options?: {
    onSuccess?: (url: string) => void;
    onError?: (error: Error) => void;
  },
) {
  const { useExternalQuery, urlShareSignature } = useExternalBidQuery();
  const { mutateAsync: exportBidReport } = useGraphQlMutation(exportBidReportAsPDF);

  return useMutation<string, Error, void>(async () => {
    if (!useExternalQuery) {
      const { exportBidReportAsPDF } = await exportBidReport({ input: { id } });
      return exportBidReportAsPDF.url;
    }

    if (!urlShareSignature) throw new Error("Missing URL share signature");
    const { url } = await getBidReportPDFUrlForExternalUser(id, urlShareSignature);
    return url;
  }, options);
}
